import { modals } from 'ducks';
import queryString from 'query-string';
import React from 'react';
import { connect } from 'react-redux';
import { faDownload } from '@fortawesome/pro-solid-svg-icons/faDownload';
import PropTypes from 'prop-types';
import BulkAction from './BulkAction';

const BulkExportAction = ({
  dispatch, location, url, type, opts, title, message, dateFilter, schoolYearId, disabled, depth
}) => {
  const beginExport = () => {
    const downloadMessage = message || (
      <React.Fragment>
        Your file is being prepared. You can safely close this modal and continue working. The report will automatically
        download when completed and will also be available on the
        {' '}
        <a href='/setup/user_jobs' target='_blank'>User Jobs page.</a>
      </React.Fragment>
    );

    const params = {
      ...queryString.parse(location.search),
      ...((dateFilter && dateFilter.queryParams) || {}),
      ...((schoolYearId && {school_year_id: schoolYearId}) || {}),
      sub_type: type,
      opts
    };

    dispatch(modals.actions.show('Downloader', {
      url,
      async: true,
      message: downloadMessage,
      params
    }));
  };

  return (
    <BulkAction
      title={title || 'Export to CSV'}
      icon={faDownload}
      onClick={() => beginExport()}
      disabled={disabled}
      depth={depth}
    />
  );
};

BulkExportAction.propTypes = {
  location: PropTypes.object.isRequired,
  url: PropTypes.string.isRequired,
  type: PropTypes.string,
  opts: PropTypes.object,
  title: PropTypes.string,
  message: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.object.isRequired]),
  dateFilter: PropTypes.object,
  disabled: PropTypes.bool,
  depth: PropTypes.number
};

BulkExportAction.defaultProps = {
  type: '',
  opts: {},
  title: 'Export to CSV',
  dateFilter: undefined,
  disabled: false,
  depth: 1
};

export default connect()(BulkExportAction);
